// extracted by mini-css-extract-plugin
module.exports = {"TooltipIcon":"Tooltip_TooltipIcon__w3v5t","content":"Tooltip_content__cF5EF"};